import HttpRequest from "./HttpRequest"



class AlertConfigurationsService {

  baseUrl = '/alerts/v1/alerts-configurations'

  httpRequest = new HttpRequest()

  async save(data) {

    if (data.id) {
      return this.httpRequest.put(`${this.baseUrl}/${data.id}`, data)
    }
    return this.httpRequest.post(`${this.baseUrl}`, data)
  }

  async getAlertById(id) {
    return this.httpRequest.get(`${this.baseUrl}/${id}`)
  }

  async deleteById(id) {
    return this.httpRequest.delete(`${this.baseUrl}/${id}`)
  }
}

export {AlertConfigurationsService}



// WEBPACK FOOTER //
// ./src/services/AlertConfigurationsService.js